import React, { useState } from 'react'
    import { Mail, Phone, MapPin, Send, CheckCircle } from 'lucide-react'
    import toast from 'react-hot-toast'

    const Contact = () => {
      const [formData, setFormData] = useState({
        name: '',
        email: '',
        company: '',
        phone: '',
        service: '',
        message: ''
      })
      const [isSubmitting, setIsSubmitting] = useState(false)

      const services = [
        'Data Engineering & Analytics',
        'AI Agent Development',
        'Generative AI & LLM Integration',
        'Healthcare Solutions',
        'Financial Services Compliance',
        'Enterprise Digital Transformation',
        'Other'
      ]

      const handleChange = (e) => {
        setFormData({
          ...formData,
          [e.target.name]: e.target.value
        })
      }

      const handleSubmit = async (e) => {
        e.preventDefault()
        setIsSubmitting(true)

        try {
          // Simulate API call
          await new Promise(resolve => setTimeout(resolve, 1000))
          
          toast.success('Thank you for your inquiry! We\'ll get back to you within 24 hours.')
          setFormData({
            name: '',
            email: '',
            company: '',
            phone: '',
            service: '',
            message: ''
          })
        } catch (error) {
          toast.error('Something went wrong. Please try again.')
        } finally {
          setIsSubmitting(false)
        }
      }

      const contactInfo = [
        {
          icon: <Mail className="h-6 w-6" />,
          title: "Email",
          details: "connect@tulians.com",
          description: "Send us an email anytime"
        },
        {
          icon: <Phone className="h-6 w-6" />,
          title: "Phone",
          details: "Available upon request",
          description: "Let's schedule a call"
        },
        {
          icon: <MapPin className="h-6 w-6" />,
          title: "Offices",
          details: "Pune, India | USA",
          description: "Global presence, local expertise"
        }
      ]

      return (
        <div className="min-h-screen bg-white" data-component-path="src/pages/Contact.jsx" data-component-line="1:4" data-component-id="src/pages/Contact.jsx:1:4">
          {/* Hero Section */}
          <section className="bg-gradient-to-br from-blue-50 to-purple-50 py-20" data-component-path="src/pages/Contact.jsx" data-component-line="3:6" data-component-id="src/pages/Contact.jsx:3:6">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="src/pages/Contact.jsx" data-component-line="4:8" data-component-id="src/pages/Contact.jsx:4:8">
              <div className="text-center" data-component-path="src/pages/Contact.jsx" data-component-line="5:10" data-component-id="src/pages/Contact.jsx:5:10">
                <h1 className="text-5xl font-bold text-gray-900 mb-6" data-component-path="src/pages/Contact.jsx" data-component-line="6:12" data-component-id="src/pages/Contact.jsx:6:12">
                  Let's Build Your <span className="gradient-text" data-component-path="src/pages/Contact.jsx" data-component-line="7:14" data-component-id="src/pages/Contact.jsx:7:14">Autonomous Future</span>
                </h1>
                <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-component-path="src/pages/Contact.jsx" data-component-line="9:12" data-component-id="src/pages/Contact.jsx:9:12">
                  Ready to transform your business with intelligent automation? Let's schedule a discovery call to identify the first high-impact workflow you can automate.
                </p>
              </div>
            </div>
          </section>

          {/* Contact Form & Info */}
          <section className="py-20" data-component-path="src/pages/Contact.jsx" data-component-line="16:6" data-component-id="src/pages/Contact.jsx:16:6">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-component-path="src/pages/Contact.jsx" data-component-line="17:8" data-component-id="src/pages/Contact.jsx:17:8">
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-12" data-component-path="src/pages/Contact.jsx" data-component-line="18:10" data-component-id="src/pages/Contact.jsx:18:10">
                {/* Contact Info */}
                <div className="lg:col-span-1" data-component-path="src/pages/Contact.jsx" data-component-line="20:12" data-component-id="src/pages/Contact.jsx:20:12">
                  <h2 className="text-2xl font-bold text-gray-900 mb-8" data-component-path="src/pages/Contact.jsx" data-component-line="21:14" data-component-id="src/pages/Contact.jsx:21:14">Get in Touch</h2>
                  
                  <div className="space-y-6" data-component-path="src/pages/Contact.jsx" data-component-line="23:14" data-component-id="src/pages/Contact.jsx:23:14">
                    {contactInfo.map((info, index) => (
                      <div key={index} className="flex items-start space-x-4" data-component-path="src/pages/Contact.jsx" data-component-line="24:16" data-component-id="src/pages/Contact.jsx:24:16">
                        <div className="flex-shrink-0 w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center text-blue-600" data-component-path="src/pages/Contact.jsx" data-component-line="25:18" data-component-id="src/pages/Contact.jsx:25:18">
                          {info.icon}
                        </div>
                        <div data-component-path="src/pages/Contact.jsx" data-component-line="28:18" data-component-id="src/pages/Contact.jsx:28:18">
                          <h3 className="text-lg font-semibold text-gray-900" data-component-path="src/pages/Contact.jsx" data-component-line="29:20" data-component-id="src/pages/Contact.jsx:29:20">{info.title}</h3>
                          <p className="text-blue-600 font-medium" data-component-path="src/pages/Contact.jsx" data-component-line="30:20" data-component-id="src/pages/Contact.jsx:30:20">{info.details}</p>
                          <p className="text-gray-600 text-sm" data-component-path="src/pages/Contact.jsx" data-component-line="31:20" data-component-id="src/pages/Contact.jsx:31:20">{info.description}</p>
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Benefits */}
                  <div className="mt-12 p-6 bg-gray-50 rounded-xl" data-component-path="src/pages/Contact.jsx" data-component-line="36:14" data-component-id="src/pages/Contact.jsx:36:14">
                    <h3 className="text-lg font-semibold text-gray-900 mb-4" data-component-path="src/pages/Contact.jsx" data-component-line="37:16" data-component-id="src/pages/Contact.jsx:37:16">What to Expect</h3>
                    <ul className="space-y-3" data-component-path="src/pages/Contact.jsx" data-component-line="38:16" data-component-id="src/pages/Contact.jsx:38:16">
                      {[
                        'Free 30-minute discovery call',
                        'Custom solution roadmap',
                        'ROI analysis and timeline',
                        'No-obligation proposal'
                      ].map((benefit, index) => (
                        <li key={index} className="flex items-center space-x-2" data-component-path="src/pages/Contact.jsx" data-component-line="44:18" data-component-id="src/pages/Contact.jsx:44:18">
                          <CheckCircle className="h-5 w-5 text-green-600" data-component-path="src/pages/Contact.jsx" data-component-line="45:20" data-component-id="src/pages/Contact.jsx:45:20" />
                          <span className="text-gray-700" data-component-path="src/pages/Contact.jsx" data-component-line="46:20" data-component-id="src/pages/Contact.jsx:46:20">{benefit}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                {/* Contact Form */}
                <div className="lg:col-span-2" data-component-path="src/pages/Contact.jsx" data-component-line="53:12" data-component-id="src/pages/Contact.jsx:53:12">
                  <div className="bg-white rounded-xl shadow-lg p-8" data-component-path="src/pages/Contact.jsx" data-component-line="54:14" data-component-id="src/pages/Contact.jsx:54:14">
                    <h2 className="text-2xl font-bold text-gray-900 mb-6" data-component-path="src/pages/Contact.jsx" data-component-line="55:16" data-component-id="src/pages/Contact.jsx:55:16">Start Your Journey</h2>
                    
                    <form onSubmit={handleSubmit} className="space-y-6" data-component-path="src/pages/Contact.jsx" data-component-line="57:16" data-component-id="src/pages/Contact.jsx:57:16">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-component-path="src/pages/Contact.jsx" data-component-line="58:18" data-component-id="src/pages/Contact.jsx:58:18">
                        <div data-component-path="src/pages/Contact.jsx" data-component-line="59:20" data-component-id="src/pages/Contact.jsx:59:20">
                          <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2" data-component-path="src/pages/Contact.jsx" data-component-line="60:22" data-component-id="src/pages/Contact.jsx:60:22">
                            Full Name *
                          </label>
                          <input
                            type="text"
                            id="name"
                            name="name"
                            required
                            value={formData.name}
                            onChange={handleChange}
                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
                            placeholder="Your full name"
                            data-component-path="src/pages/Contact.jsx" data-component-line="63:22" data-component-id="src/pages/Contact.jsx:63:22"
                          />
                        </div>
                        
                        <div data-component-path="src/pages/Contact.jsx" data-component-line="74:20" data-component-id="src/pages/Contact.jsx:74:20">
                          <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2" data-component-path="src/pages/Contact.jsx" data-component-line="75:22" data-component-id="src/pages/Contact.jsx:75:22">
                            Email Address *
                          </label>
                          <input
                            type="email"
                            id="email"
                            name="email"
                            required
                            value={formData.email}
                            onChange={handleChange}
                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
                            placeholder="your.email@company.com"
                            data-component-path="src/pages/Contact.jsx" data-component-line="78:22" data-component-id="src/pages/Contact.jsx:78:22"
                          />
                        </div>
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-component-path="src/pages/Contact.jsx" data-component-line="89:18" data-component-id="src/pages/Contact.jsx:89:18">
                        <div data-component-path="src/pages/Contact.jsx" data-component-line="90:20" data-component-id="src/pages/Contact.jsx:90:20">
                          <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-2" data-component-path="src/pages/Contact.jsx" data-component-line="91:22" data-component-id="src/pages/Contact.jsx:91:22">
                            Company
                          </label>
                          <input
                            type="text"
                            id="company"
                            name="company"
                            value={formData.company}
                            onChange={handleChange}
                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
                            placeholder="Your company name"
                            data-component-path="src/pages/Contact.jsx" data-component-line="94:22" data-component-id="src/pages/Contact.jsx:94:22"
                          />
                        </div>
                        
                        <div data-component-path="src/pages/Contact.jsx" data-component-line="103:20" data-component-id="src/pages/Contact.jsx:103:20">
                          <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2" data-component-path="src/pages/Contact.jsx" data-component-line="104:22" data-component-id="src/pages/Contact.jsx:104:22">
                            Phone Number
                          </label>
                          <input
                            type="tel"
                            id="phone"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
                            placeholder="+1 (555) 123-4567"
                            data-component-path="src/pages/Contact.jsx" data-component-line="107:22" data-component-id="src/pages/Contact.jsx:107:22"
                          />
                        </div>
                      </div>

                      <div data-component-path="src/pages/Contact.jsx" data-component-line="116:18" data-component-id="src/pages/Contact.jsx:116:18">
                        <label htmlFor="service" className="block text-sm font-medium text-gray-700 mb-2" data-component-path="src/pages/Contact.jsx" data-component-line="117:20" data-component-id="src/pages/Contact.jsx:117:20">
                          Service of Interest
                        </label>
                        <select
                          id="service"
                          name="service"
                          value={formData.service}
                          onChange={handleChange}
                          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
                          data-component-path="src/pages/Contact.jsx" data-component-line="120:20" data-component-id="src/pages/Contact.jsx:120:20"
                        >
                          <option value="" data-component-path="src/pages/Contact.jsx" data-component-line="126:22" data-component-id="src/pages/Contact.jsx:126:22">Select a service</option>
                          {services.map((service, index) => (
                            <option key={index} value={service} data-component-path="src/pages/Contact.jsx" data-component-line="128:24" data-component-id="src/pages/Contact.jsx:128:24">{service}</option>
                          ))}
                        </select>
                      </div>

                      <div data-component-path="src/pages/Contact.jsx" data-component-line="133:18" data-component-id="src/pages/Contact.jsx:133:18">
                        <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2" data-component-path="src/pages/Contact.jsx" data-component-line="134:20" data-component-id="src/pages/Contact.jsx:134:20">
                          Project Details
                        </label>
                        <textarea
                          id="message"
                          name="message"
                          rows={4}
                          value={formData.message}
                          onChange={handleChange}
                          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors resize-none"
                          placeholder="Tell us about your project, challenges, and goals..."
                          data-component-path="src/pages/Contact.jsx" data-component-line="137:20" data-component-id="src/pages/Contact.jsx:137:20"
                        />
                      </div>

                      <button
                        type="submit"
                        disabled={isSubmitting}
                        className="w-full btn-primary flex items-center justify-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed"
                        data-component-path="src/pages/Contact.jsx" data-component-line="147:18" data-component-id="src/pages/Contact.jsx:147:18"
                      >
                        <span data-component-path="src/pages/Contact.jsx" data-component-line="152:20" data-component-id="src/pages/Contact.jsx:152:20">{isSubmitting ? 'Sending...' : 'Send Message'}</span>
                        <Send className="h-5 w-5" data-component-path="src/pages/Contact.jsx" data-component-line="153:20" data-component-id="src/pages/Contact.jsx:153:20" />
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* CTA Section */}
          <section className="py-20 bg-gradient-to-r from-blue-600 to-purple-600 text-white" data-component-path="src/pages/Contact.jsx" data-component-line="162:6" data-component-id="src/pages/Contact.jsx:162:6">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-component-path="src/pages/Contact.jsx" data-component-line="163:8" data-component-id="src/pages/Contact.jsx:163:8">
              <h2 className="text-3xl font-bold mb-4" data-component-path="src/pages/Contact.jsx" data-component-line="164:10" data-component-id="src/pages/Contact.jsx:164:10">
                Ready to Get Started?
              </h2>
              <p className="text-xl text-blue-100 mb-8 max-w-3xl mx-auto" data-component-path="src/pages/Contact.jsx" data-component-line="167:10" data-component-id="src/pages/Contact.jsx:167:10">
                Join the growing number of companies that trust Tulian to engineer their autonomous future.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center" data-component-path="src/pages/Contact.jsx" data-component-line="170:10" data-component-id="src/pages/Contact.jsx:170:10">
                <a 
                  href="mailto:connect@tulians.com" 
                  className="inline-flex items-center space-x-2 bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors"
                  data-component-path="src/pages/Contact.jsx" data-component-line="171:12" data-component-id="src/pages/Contact.jsx:171:12"
                >
                  <Mail className="h-5 w-5" data-component-path="src/pages/Contact.jsx" data-component-line="175:14" data-component-id="src/pages/Contact.jsx:175:14" />
                  <span data-component-path="src/pages/Contact.jsx" data-component-line="176:14" data-component-id="src/pages/Contact.jsx:176:14">Email Us Directly</span>
                </a>
              </div>
            </div>
          </section>
        </div>
      )
    }

    export default Contact